import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Grid2 as Grid, TextField} from 'views/components';
import {Translate, translate} from 'views/module';

import backend from 'utils/backend';

const errorMessage = (error) => {
  return translate(`loomLead.LoomLeadDetail.Header.ChangeName.Errors.${error.code === 'CLT_004' ? 'CLT_004' : 'Default'}`);
};

// Writes to Loom only. A lead that also lives in client-fe keeps its old name there, and the next
// client-fe edit to that lead sends the old name back to Loom.
const ClientNameEdit = (props) => {
  const {clientData, onClose, onSaved} = props;
  const progressWrap = props.statusProgressWrap;

  const [firstName, setFirstName] = React.useState(clientData.firstName);
  const [lastName, setLastName] = React.useState(clientData.lastName);
  const [saving, setSaving] = React.useState(false);

  const save = async () => {
    setSaving(true);
    await progressWrap(async () => {
      await backend.loom.loomLead.renameClient(clientData.clientId, {
        firstName: firstName.trim(),
        lastName: lastName.trim(),
      });
      onSaved();
    }, {
      onErrorMessage: errorMessage,
      debugString: 'LOOM_LEAD_RENAME',
    });
    setSaving(false);
  };

  return (
    <Dialog onClose={onClose}>
      <DialogTitle onClose={onClose}>
        <Translate expression='loomLead.LoomLeadDetail.Header.ChangeName.Title' />
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{pt: 1}}>
          <Grid size={{xs: 12, sm: 6}}>
            <TextField
              fullWidth
              required
              label={translate('loomLead.LoomLeadDetail.Header.ChangeName.FirstName')}
              value={firstName}
              onChange={setFirstName}
            />
          </Grid>
          <Grid size={{xs: 12, sm: 6}}>
            <TextField
              fullWidth
              required
              label={translate('loomLead.LoomLeadDetail.Header.ChangeName.LastName')}
              value={lastName}
              onChange={setLastName}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button disabled={!firstName.trim() || !lastName.trim() || saving} onClick={save}>
          <Translate expression='generic.Save' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ClientNameEdit.propTypes = {
  clientData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSaved: PropTypes.func.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(ClientNameEdit));
